import React, { useState } from 'react'
import styled from 'styled-components'

import { Col, Row } from '../../../../1stlog-ui/src/components/Bootstrap'
import { FieldPrefix } from '../../../../1stlog-ui/src/components/Field'
import SubmitButton from '../SubmitButton'
import useOrderEntry from '../useOrderEntry'
import ClientNotifications from './ClientNotifications'
import Colis from './Colis'
import CustomerAddress from './CustomerAddress'
import CustomPrice from './CustomPrice'
import Customs from './Customs'
import DeliveryAddress from './DeliveryAddress'
import FieldJumper from './FieldJumper'
import ImporterAddress from './ImporterAddress'
import InvoiceAddress from './InvoiceAddress'
import Misc from './Misc'
import NeutralSender from './NeutralSender'
import PickupAddress from './PickupAddress'
import Shipment from './Shipment'
import Transport from './Transport'

const Wrapper = styled.div``

const Form = (): React.ReactElement => {
  const { DebugControls, preset, cancelButton } = useOrderEntry()

  const [ref, setRef] = useState<HTMLDivElement>()

  const handleRef = (node: HTMLDivElement): void => {
    setRef(node)
  }

  return (
    <Wrapper ref={handleRef}>
      {ref && (
        <>
          <FieldJumper containerRef={ref} />
          {DebugControls && <DebugControls />}
          <Row>
            <Col md={6}>
              <FieldPrefix prefix="customer">
                <CustomerAddress />
              </FieldPrefix>
              <FieldPrefix prefix="pickup">
                <PickupAddress />
              </FieldPrefix>
              <FieldPrefix prefix="invoice">
                <InvoiceAddress />
              </FieldPrefix>
              <FieldPrefix prefix="neutralSender">
                <NeutralSender />
              </FieldPrefix>
              <FieldPrefix prefix="importer">
                <ImporterAddress />
              </FieldPrefix>
            </Col>
            <Col md={6}>
              <FieldPrefix prefix="delivery">
                <DeliveryAddress />
              </FieldPrefix>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Transport />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <CustomPrice />
            </Col>
          </Row>
          {/* TODO: Linehaul / Linienverlauf */}
          <Row>
            <Col md={12}>
              <Shipment />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Colis />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Customs />
            </Col>
          </Row>
          <Row>
            <Col>
              <ClientNotifications />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Misc />
            </Col>
          </Row>
          <div className="d-flex justify-content-end">
            {cancelButton}
            <SubmitButton />
          </div>
        </>
      )}
    </Wrapper>
  )
}

export default Form
